import React from "react";
import {ColumnProps} from "antd/es/table";
import {FIELD_TYPE} from "types/enums";
const {INPUT, TEXT_AREA} = FIELD_TYPE;

const columns: ColumnProps<any>[] = [
  {
    key: "1",
    title: "STT",
    dataIndex: "",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    width: 80,
    align: "center",
  },
  {
    key: "2",
    title: "Mã hãng sx",
    dataIndex: "id",
    width: 150,
  },
  {
    key: "name",
    title: "Tên hãng sx",
    dataIndex: "name",
    width: 350,
  },
  {
    key: "description",
    title: "Ghi chú",
    dataIndex: "description",
  },
  {
    key: "action",
    title: "",
    dataIndex: "action",
    width: 150,
  },
];
const dataFields: any[] = [
  {
    type: INPUT,
    label: "Mã hãng sx",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên hãng sx",
    name: "name",
    rules: [{required: true, message: "Chưa nhập Tên hãng sx"}],
  },
  {
    type: TEXT_AREA,
    label: "Ghi chú",
    name: "description",
  },
];
export {columns, dataFields};
